import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HalalFinder from "@/pages/HalalFinder";
import SponsorSuccess from "@/pages/SponsorSuccess";
import SponsorCancel from "@/pages/SponsorCancel";
import AdminPage from "@/pages/AdminPage";
import OwnerPage from "@/pages/OwnerPage";
import RestaurantPermalink from "@/pages/RestaurantPermalink";
import UnderConstruction from "@/pages/UnderConstruction";
import InstallPrompt from "@/components/InstallPrompt";

const MAINTENANCE_MODE =
  String(process.env.REACT_APP_MAINTENANCE_MODE || "").toLowerCase() === "true";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {MAINTENANCE_MODE ? (
            <>
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/owner" element={<OwnerPage />} />
              <Route path="*" element={<UnderConstruction />} />
            </>
          ) : (
            <>
              <Route path="/" element={<HalalFinder />} />
              <Route path="/sponsor/success" element={<SponsorSuccess />} />
              <Route path="/sponsor/cancel" element={<SponsorCancel />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/owner" element={<OwnerPage />} />
              <Route path="/r/:placeId" element={<RestaurantPermalink />} />
            </>
          )}
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" toastOptions={{ className: "pointer-events-auto" }} />
      {!MAINTENANCE_MODE && <InstallPrompt />}
    </div>
  );
}

export default App;
